"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const lodash_1 = require("lodash");
const common_components_1 = require("@zapier/common-components");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("@zapier/theme");
const SamplePickerButtonIcon_1 = __importDefault(require("./SamplePickerButtonIcon"));
const SamplePickerDropdownMenu_1 = __importDefault(require("./SamplePickerDropdownMenu/SamplePickerDropdownMenu"));
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        border: `1px solid ${theme_1.Colors.grey200}`,
        borderRadius: 10,
    },
    dropdownMenuContainer: {
        position: 'relative',
        minWidth: 400,
    },
});
function SamplePicker(props) {
    const renderIcon = () => (common_utils_1.isolateComponent(SamplePickerButtonIcon_1.default, { selectedApi: props.selectedApi }));
    const renderFloatingMenu = (floatingMenuProps) => {
        const onClose = floatingMenuProps.closeMenu;
        return (common_utils_1.isolateComponent(common_components_1.Keydown, { handlers: { escape: onClose } },
            common_utils_1.isolateComponent("div", { css: Styles.dropdownMenuContainer },
                common_utils_1.isolateComponent(design_system_1.FloatingBox, { align: "stretch", position: "south" },
                    common_utils_1.isolateComponent(common_components_1.ClickPropagationBarrier, null,
                        common_utils_1.isolateComponent(SamplePickerDropdownMenu_1.default, Object.assign({}, floatingMenuProps, { isBuiltInApp: props.isBuiltInApp, isLoadingMore: props.isLoadingMore, isUnableToFindMoreEvents: props.isUnableToFindMoreEvents, onLoadMore: props.onLoadMore, sampleNoun: props.sampleNoun })))))));
    };
    if (props.value) {
        return (common_utils_1.isolateComponent("div", { css: Styles.root },
            common_utils_1.isolateComponent(design_system_1.Dropdown, { color: "white", getKeyForItem: (item) => String(item._zap_data_sample_id), initialSelectedItem: props.value, items: props.samples, key: lodash_1.get(props.value, '_zap_data_sample_id'), onBlur: () => { }, onChange: props.onChange, renderFloatingMenu: renderFloatingMenu, renderIcon: renderIcon, size: "medium" })));
    }
    return null;
}
exports.default = SamplePicker;
